export default __webpack_public_path__ + "static/media/burger.a6a9af27.svg";